import { useQuery } from 'react-query';
import { myResumeService } from 'services/cv';
import { useSelector } from 'react-redux';
import UseModal from 'hooks/use-modal';
import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';

import EmptyState from 'components/pages/myresume/EmptyState';
import ResumeFilled from 'components/pages/myresume/ResumeFilled';
import Modal from '@core/components/Modal/Modal';
import UserFullName from 'components/common/userfullname/UserFullName';

import NotVerifiedImg from 'assets/icons/message-time.svg';

import Spinner from '@core/components/spinner/Spinner';
import GoPremiumBanner from '@core/components/gopremiumbanner/GoPremiumBanner';

import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';

import classes from './myresume.module.scss';


const MyResume = () => {
	const seoProps = generateSeoProps({
		title: 'Resume Builder: Craft Job-Ready Pharma CVs - Pharmuni',
		description: 'Edit your profile, achievements and skills, then generate a resume that highlights GMP expertise—share with recruiters and boost your pharma career.',
		canonical: 'profile/my-resume',
	});
	const hasSubscription = useSelector(state => state.user.hasSubscription);
	const availableTrialDays = useSelector(state => state.user.available_trial_days);
	const {
		show: showFullname,
		destroyModal: destroyFullnameModal,
		showModal: showFullnameModal
	} = UseModal();
	const { data, isLoading, refetch, error } = useQuery(['user-resume'], myResumeService, {
		onError: (error) => {
			if (error.response.status === 422) {
				showFullnameModal();
			}
		}
	});
	return (
		<>
			<NextSeo {...seoProps} />
			{((data && !isLoading) || error?.response?.status === 422) ? (
				<>
					{!hasSubscription && availableTrialDays === 0 && (<GoPremiumBanner />)}

					{data?.data?.has_resume ? (

						<ResumeFilled
							data={data?.data}
							refetchMyResume={refetch}
							hasSubscription={true}
						/>

					) : (
						<EmptyState smart_cv_import_access_status={data?.data?.smart_cv_import_access_status} nameError={error?.response?.status} refetch={refetch} />
					)}
				</>
			) : isLoading && !error ? (
				<div
					className={`${classes['loading']} d-flex flex-row align-items-center justify-content-center`}>
					<Spinner />
				</div>
			) : (
				<>
					{error?.response?.status === 428 ? (
						<div
							className={`d-flex flex-column align-items-center justify-content-center gap-3 py-3 ${classes['my-resume-unverified-profile']}`}>
							<NotVerifiedImg />
							<h3>Email not approved</h3>
							<p>Your email has not been approved yet.</p>
						</div>
					) : (
						<h5>Something went wrong please try again later!</h5>
					)}
				</>
			)}
			<Modal type={MOBILE_SLIDE_UP} show={showFullname} closeHandler={destroyFullnameModal}>
				<div className={`${classes['user-fullname-wrapper-modal']} d-flex flex-column gap-2`}>
					<UserFullName
						title=""
						description="We need your name to continue. Enter your name below. Please note that your name is not editable later"
						callback={() => {
							refetch();
							destroyFullnameModal();
						}}
					/>
				</div>
			</Modal>
		</>
	);
};
export default MyResume;
